import type { IconNameType } from "@UI/types/icons.ts";

/**
 * Icons the DS can paint with the AI gradient. Mirrors `GRADIENT_ICONS` in
 * `scripts/generateIcons.mjs`, which emits their mask images; `color="ai"`
 * falls back to a flat colour for anything not listed here.
 */
export const GRADIENT_ICONS = [
  "check",
  "clock",
  "email",
  "lightbulb",
  "note",
  "send",
  "spark",
  "sparkling-line",
] as const;

export type GradientIconName = Extract<
  IconNameType,
  (typeof GRADIENT_ICONS)[number]
>;
